"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon_1 = __importDefault(require("../common/FirstSection/CheckIcon"));
var styles_1 = require("../common/styles");
var List_1 = __importDefault(require("../common/List"));
var shirt1_png_1 = __importDefault(require("./assets/shirt1.png"));
var shirt2_webp_1 = __importDefault(require("./assets/shirt2.webp"));
var shirt3_png_1 = __importDefault(require("./assets/shirt3.png"));
var shirt4_jpg_1 = __importDefault(require("./assets/shirt4.jpg"));
var shirt5_webp_1 = __importDefault(require("./assets/shirt5.webp"));
var shirt6_jpg_1 = __importDefault(require("./assets/shirt6.jpg"));
var shirt7_jpg_1 = __importDefault(require("./assets/shirt7.jpg"));
var shirt8_jpg_1 = __importDefault(require("./assets/shirt8.jpg"));
var shirt9_jpg_1 = __importDefault(require("./assets/shirt9.jpg"));
var shirt10_jpg_1 = __importDefault(require("./assets/shirt10.jpg"));
var shirt11_jpg_1 = __importDefault(require("./assets/shirt11.jpg"));
var shirt12_jpg_1 = __importDefault(require("./assets/shirt12.jpg"));
var shirt13_jpg_1 = __importDefault(require("./assets/shirt13.jpg"));
var hoodie1_png_1 = __importDefault(require("./assets/hoodie1.png"));
var hoodie2_png_1 = __importDefault(require("./assets/hoodie2.png"));
var hoodie3_webp_1 = __importDefault(require("./assets/hoodie3.webp"));
var hoodie4_png_1 = __importDefault(require("./assets/hoodie4.png"));
var hoodie5_webp_1 = __importDefault(require("./assets/hoodie5.webp"));
var hoodie6_png_1 = __importDefault(require("./assets/hoodie6.png"));
var hoodie7_jpg_1 = __importDefault(require("./assets/hoodie7.jpg"));
var hoodie8_jpg_1 = __importDefault(require("./assets/hoodie8.jpg"));
var cap1_png_1 = __importDefault(require("./assets/cap1.png"));
var cap2_png_1 = __importDefault(require("./assets/cap2.png"));
var cap3_png_1 = __importDefault(require("./assets/cap3.png"));
var cap4_png_1 = __importDefault(require("./assets/cap4.png"));
var cap5_jpg_1 = __importDefault(require("./assets/cap5.jpg"));
var cap6_jpg_1 = __importDefault(require("./assets/cap6.jpg"));
var bg_png_1 = __importDefault(require("./FirstSection/bg.png"));
exports.default = {
    bgimageStyle: "\n        max-width: 840px;\n        top: -30px;\n        right: -30px;\n    ",
    FirstSectionBgImage: bg_png_1.default,
    axiosLink: '/api/products/classic_tee?format=json',
    productLink: '/classic_tees/new_v2',
    productNamePlural: 'изделия',
    seoText: (react_1.default.createElement(styles_1.Text, null, "\u041E\u0431\u0449\u0438\u0439 \u0441\u0442\u0438\u043B\u044C \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u0442 \u0441\u043F\u043B\u043E\u0442\u0438\u0442\u044C\u0441\u044F \u2013 \u044D\u0442\u043E \u0432\u0430\u0436\u043D\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u0435. \u041E\u0434\u0435\u0436\u0434\u0430 \u0441 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u043E\u043C \u043E\u0442\u043B\u0438\u0447\u043D\u043E \u0441\u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430 \u044D\u0442\u0443 \u0446\u0435\u043B\u044C. \u0422\u0430\u043A \u0438 \u043E\u043A\u0440\u0443\u0436\u0430\u044E\u0449\u0438\u0435, \u0438 \u0441\u0430\u043C \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043D\u0438\u043C\u0430\u0442\u044C \u0441\u0432\u043E\u044E \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u044C \u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438. \u041D\u043E\u0441\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \u0441 \u0443\u0434\u043E\u0432\u043E\u043B\u044C\u0441\u0442\u0432\u0438\u0435\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u043E\u0434\u0435\u0436\u0434\u0435 \u043D\u0430 \u0437\u0430\u043A\u0430\u0437. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0430\u043C\u0438 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u0443\u0436\u043D\u044B\u0435 \u043F\u0440\u0438\u043D\u0442\u044B \u0438\u043B\u0438 \u043D\u0430\u0434\u043F\u0438\u0441\u0438 \u0438\u043B\u0438 \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u0434\u0438\u0437\u0430\u0439\u043D\u0430 \u0443 \u043D\u0430\u0448\u0438\u0445 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u043E\u0432. \u041F\u0440\u0438\u043C\u0435\u0440\u044C\u0442\u0435 \u0440\u0438\u0441\u0443\u043D\u043E\u043A \u0432 \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0435 \u0438 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u0435\u0439 \u00AB\u0420\u0435\u0430\u043B\u0438\u0441\u0442\u0438\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u00BB, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043D\u044F\u0442\u044C, \u043A\u0430\u043A \u043E\u0434\u0435\u0436\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u0433\u043B\u044F\u0434\u0435\u0442\u044C \u043D\u0430 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0435.")),
    firstSectionTitle: (react_1.default.createElement(styles_1.MainTitle, null,
        "\u041F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u043E\u0434\u0435\u0436\u0434\u0435",
        react_1.default.createElement("br", null),
        " \u043D\u0430 \u0437\u0430\u043A\u0430\u0437")),
    firstSectionText: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Text, null,
            "\u041D\u0430\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u043E\u0432, \u043D\u0430\u0434\u043F\u0438\u0441\u0435\u0439, \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u043D\u0430 \u0444\u0443\u0442\u0431\u043E\u043B\u043A\u0438, ",
            react_1.default.createElement("br", null),
            "\u0442\u043E\u043B\u0441\u0442\u043E\u0432\u043A\u0438, \u0431\u0435\u0439\u0441\u0431\u043E\u043B\u043A\u0438 \u043E\u0442 1 \u0448\u0442. \u0434\u043E 10 000 \u0442\u044B\u0441. \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440\u043E\u0432"),
        react_1.default.createElement(List_1.default, { icon: react_1.default.createElement(CheckIcon_1.default, null) },
            react_1.default.createElement(styles_1.Text, null, "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430 \u0438 \u0441\u0443\u0432\u0435\u043D\u0438\u0440\u044B \u043F\u043E\u0434 \u043A\u043B\u044E\u0447"),
            react_1.default.createElement(styles_1.Text, null, "\u041F\u043E\u043C\u043E\u0449\u044C \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0430"),
            react_1.default.createElement(styles_1.Text, null, "\u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0434\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"),
            react_1.default.createElement(styles_1.Text, null, "\u0428\u0438\u0440\u043E\u043A\u0438\u0439 \u0432\u044B\u0431\u043E\u0440 \u0438\u0437\u0434\u0435\u043B\u0438\u0439: \u043E\u0442 \u043F\u0440\u043E\u043C\u043E \u0434\u043E \u043F\u0440\u0435\u043C\u0438\u0443\u043C")))),
    productsTitle: 'Изделия для нанесения',
    products: [
        {
            link: '/classic_tees/new_v2',
            image: shirt1_png_1.default,
            text: 'Футболка мужская классическая',
        },
        {
            link: '/tees/new_v2',
            image: shirt2_webp_1.default,
            text: 'Футболка мужская базовая',
        },
        {
            link: '/oversize_tees/new_v2',
            image: shirt3_png_1.default,
            text: 'Футболка оверсайз',
        },
        {
            link: '/classic_woman_tees/new_v2',
            image: shirt4_jpg_1.default,
            text: 'Футболка женская классическая',
        },
        {
            link: '/woman_tees/new_v2',
            image: shirt5_webp_1.default,
            text: 'Футболка женская базовая',
        },
        {
            link: '/kids_tees/new_v2',
            image: shirt6_jpg_1.default,
            text: 'Футболка детская базовая',
        },
        {
            image: shirt7_jpg_1.default,
            text: 'Футболка Мужская Crusader',
        },
        {
            image: shirt8_jpg_1.default,
            text: 'Футболка мужская Regent Fit 150',
        },
        {
            image: shirt9_jpg_1.default,
            text: 'Футболка мужская T-bolka Stretch',
        },
        {
            image: shirt10_jpg_1.default,
            text: 'Футболка женская E150',
        },
        {
            image: shirt11_jpg_1.default,
            text: 'Футболка женская E150 Organic',
        },
        {
            image: shirt12_jpg_1.default,
            text: 'Футболка женская E190',
        },
        {
            image: shirt13_jpg_1.default,
            text: 'Футболка детская T-Bolka Kids',
        },
        {
            link: '/hoodies/new_v2',
            image: hoodie1_png_1.default,
            text: 'Толстовка wearcraft premium унисекс',
        },
        {
            link: '/sweatshirts/new_v2',
            image: hoodie2_png_1.default,
            text: 'Свитшот унисекс хлопковый',
        },
        {
            link: '/full_print_hoodies/new_v2',
            image: hoodie3_webp_1.default,
            text: 'Худи с полной запечаткой',
        },
        {
            link: '/oversize_hoodies/new_v2',
            image: hoodie4_png_1.default,
            text: 'Толстовка оверсайз',
        },
        {
            link: '/kids_hoodies/new_v2',
            image: hoodie5_webp_1.default,
            text: 'Детское худи',
        },
        {
            link: '/kids_zip_hoodies/new_v2',
            image: hoodie6_png_1.default,
            text: 'Толстовка детская на молнии',
        },
        {
            image: hoodie7_jpg_1.default,
            text: 'Толстовка на молнии с капюшоном Unit Siverga',
        },
        {
            image: hoodie8_jpg_1.default,
            text: 'Толстовка Stan',
        },
        {
            link: '/hats/new_v2',
            image: cap1_png_1.default,
            text: 'Кепка',
        },
        {
            link: '/snapbacks/new_v2',
            image: cap2_png_1.default,
            text: 'Кепка снепбек с прямым козырьком',
        },
        {
            link: '/caps_trucker/new_v2',
            image: cap3_png_1.default,
            text: 'Кепка тракер с сеткой',
        },
        {
            link: '/panamas/new_v2',
            image: cap4_png_1.default,
            text: 'Панама',
        },
        {
            link: '/bandanas/new_v2',
            image: cap5_jpg_1.default,
            text: 'Бандана Unit Air',
        },
        {
            image: cap6_jpg_1.default,
            text: 'Бейсболка Unit Classic',
        },
        {},
    ]
};
